import { render, staticRenderFns } from "./PickupForm.vue?vue&type=template&id=594d4a5e&scoped=true"
import script from "./PickupForm.vue?vue&type=script&lang=ts"
export * from "./PickupForm.vue?vue&type=script&lang=ts"
import style0 from "./PickupForm.vue?vue&type=style&index=0&id=594d4a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d4a5e",
  null
  
)

export default component.exports